import React from 'react';
import PropTypes from 'prop-types';
import Classes from '../Classes';

const PremiumExhibitorCarouselClip = props => (
  <div data-testId="premium-clip"  className={ props.isInnovative ? Classes.innovativeProductClip : Classes.premiumExhibitorCarouselClip}>
    <div className={Classes.premiumExhibitorCarouselClipText}>{props.text}</div>
  </div>
);

PremiumExhibitorCarouselClip.propTypes = {
  text: PropTypes.string.isRequired,
  isInnovative: PropTypes.bool,
};

export default PremiumExhibitorCarouselClip;
